export default "__VITE_ASSET__9120ae4b__"